export enum MessageEnum {
  ERROR_UPLOAD_FILE_TAP_SOLUTION = "E10",
}
